import {
  SaleResponseRelatedPressItem,
  SaleResponseRelatedPressItemHeadImage,
} from '@bonhams1793/bonhams-typescript'
import { memo } from 'react'
import isEqual from 'react-fast-compare'

import { getTranslate } from '@nx/translations'

import { LotImageTypes } from '@web/helpers/enums'
import { populateUrl } from '@web/helpers/utils/urlBuilders/populateUrl'

import { NewsAndVideos } from '../NewsAndVideos'
import translate from './NewsAndHighlights.translate.json'

const { text } = getTranslate(translate)

export const findHighlightImageUrlParams = (
  headimage: SaleResponseRelatedPressItemHeadImage
): string => {
  let use = headimage.imageuses.find(
    (e) => e.sImageUse === LotImageTypes.carousel && e.sStyleSize === 'fullsize'
  )

  if (use) {
    return use.sURLParams
  } else {
    use = headimage.imageuses.find(
      (e) =>
        e.sImageUse === LotImageTypes.carousel && e.sStyleSize === 'twothirds'
    )
    if (use) {
      return use.sURLParams
    } else {
      use = headimage.imageuses.find((e) => e.sImageUse === LotImageTypes.main)
      if (use) {
        return use.sURLParams
      }
    }
  }

  return ''
}

export const NewsAndHighlights = memo(
  ({ relatedPress, trackingCategory }: NewsAndHighlightsProps) => {
    if (!relatedPress?.length) {
      return null
    }

    const items = relatedPress.map(
      (pressRelease: SaleResponseRelatedPressItem) => {
        let image = 'https://www.bonhams.com/media/assets/img/bonhams.jpg'

        if (
          pressRelease?.headimages?.length > 0 &&
          pressRelease.headimages[0]?.grid_main_url
        ) {
          const urlParams = findHighlightImageUrlParams(
            pressRelease.headimages[0]
          )
          image = pressRelease.headimages[0].grid_main_url
          if (urlParams) {
            image = populateUrl(image, urlParams)
          }
          image = populateUrl(image, 'autosizefit=1&fill=FFFFFF')
        }

        return {
          id: pressRelease.iHeadlineNo,
          title: pressRelease.sHeadline,
          type: pressRelease.sHeadCat === 'R' ? 'video' : 'news',
          image: populateUrl(image, 'width=640'),
          headingTag: 'h3',
        } as const
      }
    )

    return (
      <NewsAndVideos
        title={text('title')}
        newsItemHeadingTag="h3"
        items={items}
        trackingCategory={trackingCategory}
      />
    )
  },
  isEqual
)

interface NewsAndHighlightsProps {
  relatedPress: SaleResponseRelatedPressItem[]
  trackingCategory: string
}
